<template>

  <!--
  <div>

    <div v-if="isGranted([permissions.SYSTEM_DATA_DISCOVERY_VIEW, permissions.SYSTEM_DATA_DISCOVERY_VIEW_OWN], system)"
         class="card data_discovery"
         qid="data-discovery-section"
         id="update_data_discovery"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="data-discovery-table-title" v-if="!showOnTask">
                {{ $t('systems.data_discovery.title') }}
              </h5>

              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_data_discovery')"
                >
                  <UpdateSingleTaskModal
                      :task="getTask('update_data_discovery')"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_data_discovery')"
                      class="cursor-pointer"
                      @click="openHelpCenter(getGuide('update_data_discovery'))"
                >
                  <font-awesome-icon icon="info-circle"/>
                  {{ $t('system.help_center_label') }}
                </span>
              </span>
            </div>
            <div class="validation-info" qid="view-dd-validation" v-if="!showOnTask">
              <span v-if="validation && validation.validation === 1" qid="data-discovery-validation-approved">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
                {{ $t('system.approved') }}
              </span>
              <span v-if="validation && validation.validation === 0" qid="data-discovery-validation-rejected">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
                {{ $t('system.rejected') }}
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.by') }}
                <span v-if="validation.created_by" qid="view-dd-validation-by">
                  {{ validation.created_by.name }}
                </span>
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.on') }}
                <span v-if="validation.created_at" qid="view-dd-validation-date">
                  {{ validation.created_at | formatDate }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm-6 text-right">
            <ValidationForm
                :object="system"
                type="data_discovery"
                scope="validate_data_discovery"
                :checklist="validationOptions"
                :disabledItems="disabledValidationOptions"
                @validationModalClose="handleValidationModalClose"
                v-if="!showOnTask && isGranted([permissions.SYSTEM_DATA_DISCOVERY_VALIDATE, permissions.SYSTEM_DATA_DISCOVERY_VALIDATE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
            ></ValidationForm>
            <span class="btn btn-success"
                    @click="showCreateDDModal()"
                    qid="data-discovery-create-button"
                    v-if="isGranted([permissions.SYSTEM_DATA_DISCOVERY_CREATE, permissions.SYSTEM_DATA_DISCOVERY_CREATE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('systems.data_discovery.create_button') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md">
          <thead>
            <tr>
              <th scope="col">
                {{ $t('systems.data_discovery.table.name') }}
              </th>
              <th scope="col" class="text-center">
                {{ $t('systems.data_discovery.table.data_scanning') }}
              </th>
              <th scope="col">
                {{ $t('system.last_updated') }}
              </th>
              <th width="200"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="object in ddTableItems">
              <td>
                <span v-if="object.data_discovery && object.data_discovery.name"
                      @click="openViewModal(object)"
                      qid="data-discovery-link"
                      class="btn btn-link btn-sm text-left cursor-pointer"
                >
                  {{ object.data_discovery.name }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="object && object.data_scanning">
                  {{ $t('systems.data_discovery.' + $options.filters.slugify(object.data_scanning)) }}
                </span>
              </td>
              <td>
                <span>
                  <Avatar :object="object.updated_by" size="xs" class="mr-2" v-if="object.updated_by"></Avatar>
                  {{ object.updated_at | formatDate }}
                </span>
              </td>
              <td align="right">
                <span v-if="object.data_discovery && object.data_discovery.name"
                      @click="openViewModal(object)"
                      qid="data-discovery-link"
                      class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </span>
                <span class="btn btn-edit"
                      qid="edit-dd-modal"
                      @click="showEditDDModal(object)"
                      v-if="isGranted([permissions.SYSTEM_DATA_DISCOVERY_EDIT, permissions.SYSTEM_DATA_DISCOVERY_EDIT_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span class="btn btn-delete"
                      qid="delete-dd-modal"
                      @click="showDDConfirmDeleteModal(object)"
                      v-if="isGranted([permissions.SYSTEM_DATA_DISCOVERY_DELETE, permissions.SYSTEM_DATA_DISCOVERY_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!ddLoading && !ddTableItems.length" qid="no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <div class="text-center mb-4" v-if="!showOnTask">
          <span class="cursor-pointer"
                @click="ddValidationShow = !ddValidationShow"
                qid="data-discovery-validation-expand"
          >
            <span class="mr-2">{{ $t('system.view_validation_log') }}</span>
            <font-awesome-icon icon="chevron-down" v-if="!ddValidationShow"/>
            <font-awesome-icon icon="chevron-up" v-if="ddValidationShow"/>
          </span>
        </div>
        <hr class="mb-0" v-show="ddValidationShow && !showOnTask">
        <ValidationList
            :object="system"
            type="data_discovery"
            :reloadList="updateValidationList"
            @validationListUpdated="setValidation"
            v-show="ddValidationShow && !showOnTask"
        ></ValidationList>
      </div>
    </div>


    <b-modal ref="delete-dd" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-dd-title">
          {{ $t('systems.data_discovery.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('systems.data_discovery.delete.description') }}
        <span v-if="itemToDelete.data_discovery">{{ itemToDelete.data_discovery.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('systems.data_discovery.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideDDConfirmDeleteModal"
                  qid="delete-dd-cancel-button"
        >
          {{ $t('systems.data_discovery.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteDD(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-dd-submit-button"
                  v-if="isGranted([permissions.SYSTEM_DATA_DISCOVERY_DELETE, permissions.SYSTEM_DATA_DISCOVERY_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
        >
          {{ $t('systems.data_discovery.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <b-modal ref="add-data-discovery" hide-footer @hide="hideCreateDDModal">
      <div class="d-block text-center">
        <h4 qid="add-dd-title">
          {{ $t('systems.data_discovery.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-dd-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="ddFormSubmit" qid="create-dd-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-dd-pg-label">
              {{ $t('systems.data_discovery.create.dd_label') }}
            </label>
            <multiselect
                v-model="selectedDD"
                :options="ddItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.data_discovery.create.dd_placeholder')"
                label="name"
                @select="resetFields"
                @search-change="loadDD"
                track-by="slug"
                qid="create-dd-form-dd"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedDD && selectedDD.data_scanning">
            <label qid="create-n-data-scanning-label">
              {{ $t('systems.data_discovery.create.ds_label') }}
            </label>
            <multiselect
                v-model="selectedDropdownOption"
                :options="dropdownOptions"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.data_discovery.create.ds_placeholder')"
                qid="create-n-form-exposed"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedDD && selectedDD.id">
            <label qid="create-dd-description-label">
              {{ $t('systems.data_discovery.create.description_label') }}
            </label>
            <b-form-textarea
              qid="dd-form-description"
              v-model="ddForm.description"
              rows="4"
              max-rows="4"
              :placeholder="$t('systems.data_discovery.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateDDModal"
                    qid="create-dd-cancel-button"
          >
            {{ $t('systems.data_discovery.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="create-dd-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('systems.data_discovery.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <b-modal ref="edit-dd" hide-footer @hide="hideEditDDModal">
      <div class="d-block text-center">
        <h4 qid="add-dd-title">
          {{ $t('systems.data_discovery.edit.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-dd-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="formEditDDSubmit" qid="edit-dd-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-dd-label">
              {{ $t('systems.data_discovery.create.dd_label') }}
            </label>
            <br>
            <span v-if="selectedDD">
              {{ selectedDD.name }}
            </span>
          </b-form-group>
          <b-form-group v-if="selectedDD && selectedDD.data_scanning">
            <label qid="create-n-data-scanning-label">
              {{ $t('systems.data_discovery.create.ds_label') }}
            </label>
            <multiselect
                v-model="selectedDropdownOption"
                :options="dropdownOptions"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.data_discovery.create.ds_placeholder')"
                qid="create-n-form-exposed"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedDD && selectedDD.id">
            <label qid="create-dd-description-label">
              {{ $t('systems.data_discovery.create.description_label') }}
            </label>
            <b-form-textarea
              qid="dd-form-description"
              v-model="ddForm.description"
              rows="4"
              max-rows="4"
              :placeholder="$t('systems.data_discovery.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditDDModal"
                    qid="create-dd-cancel-button"
          >
            {{ $t('processes.legal_basis.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-dd-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('processes.legal_basis.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <DataDiscoveryViewModal
        :object="selectedDD"
        v-if="selectedDD"
        :showModal="viewDDModal"
        @closeViewModal="closeViewModal"
    ></DataDiscoveryViewModal>

  </div>
-->

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import DataDiscoveryViewModal from '@/views/Systems/DataDiscoveryViewModal.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';

  export default {
    name: 'DataDiscoveryTable',
    data: function() {
      return {
        ddForm: {
          name: '',
          data_scanning: '',
          description: ''
        },
        error: '',
        loadingItems: false,
        selectedDD: [],
        editDDModal: false,
        selectedDDSort: '',
        selectedDDDirection: '',
        ddValidationShow: false,
        ddTableItems: [],
        ddLoading: true,
        ddItems: [],
        updateValidationList: false,
        itemToDelete: {},
        object: {},
        dropdownOptions: [],
        selectedDropdownOption: [],
        validationOptions: [],
        validation: {},
        disabledValidationOptions: [],
        buttonDisabled: false,
        viewDDModal: false,
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      system: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      DataDiscoveryViewModal,
      UpdateSingleTaskModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadDD();
      },
      system: function (value) {
        if (value && value.slug) {
          this.loadTasks('update_data_discovery');
          this.loadDataDiscovery();
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.system.id && this.$store.state.updatedObject.who_am_i == this.system.who_am_i) {
              this.system = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_data_discovery')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadDataDiscovery();
        this.loadTasks('update_data_discovery');
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.system.who_am_i,
              model_id: this.system.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'systems.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'System' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'System',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      openHelpCenter(object) {
        let topElement = document.getElementById("app");
        if (topElement.classList.contains("guide-collapsed")) {
          topElement.classList.toggle("guide-collapsed");
        }
        if (!topElement.classList.contains("activity-collapsed")) {
          topElement.classList.toggle("activity-collapsed");
        }

        this.$store.commit('storeHelpCenterState', true);
        this.$store.commit('storeActiveGuideScope', object);
      },
      resetFields() {
        this.selectedDropdownOption = null
      },
      setValidation(object) {
        this.validation = object
      },
      closeViewModal () {
        this.viewDDModal = false;
        this.selectedDD = []
      },
      openViewModal(object) {
        this.selectedDD = object
        this.viewDDModal = true
      },
      openEditDDModal(object) {
        this.selectedDD = object
      },
      showCreateDDModal() {
        this.$refs['add-data-discovery'].show()
      },
      hideCreateDDModal() {
        this.error = ''
        this.selectedDD = []
        this.selectedDropdownOption = []
        this.ddForm.description = ''
        this.loadContent();
        this.$refs['add-data-discovery'].hide()
      },
      showEditDDModal(object) {
        let self = this;
        this.selectedDD = object.data_discovery

        this.selectedDropdownOption = []
        if (object.data_scanning) {
          _.find(this.dropdownOptions, function(item) {
            if (item.value == object.data_scanning) {
              self.selectedDropdownOption = item;
            }
          });
        }

        this.ddForm.description = object.description
        this.object = object
        this.$refs['edit-dd'].show()
      },
      hideEditDDModal() {
        this.error = ''
        this.selectedDD = []
        this.selectedDropdownOption = []
        this.ddForm.description = ''
        this.loadContent();
        this.$refs['edit-dd'].hide()
      },
      showDDConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-dd'].show()
      },
      hideDDConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent();
        this.$refs['delete-dd'].hide()
      },
      handleValidationModalClose() {
        this.updateValidationList = true
        this.loadContent()
      },
      loadContent() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.system = response.data;
          self.setDisabledValidations();
        }, function() {});
      },
      loadDataDiscovery() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug + '/data-discoveries', { params:
          {
            client: this.getClient.slug,
          }
        }).then(function(response) {
          self.ddTableItems = response.data;
          self.ddLoading = false;
        }, function() {});
      },
      confirmDeleteDD(object) {
        let self = this;
        piincHttp.delete('systems/' + this.system.slug + '/data-discoveries/' + object.id).then(function() {
          self.hideDDConfirmDeleteModal();
          self.loadDataDiscovery();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('systems.data_discovery.delete.success'))
        }, function() {});
      },
      ddFormSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedDD && this.selectedDD.id) {
          formData.append("data_discovery_id", this.selectedDD.id);
        }

        formData.append("system", this.system.slug);
        formData.append("description", this.ddForm.description);

        if (this.selectedDropdownOption) {
          formData.append("data_scanning", this.selectedDropdownOption.value);
        }

        piincHttp.post('/systems/' + this.system.slug + '/data-discoveries', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('systems.data_discovery.create.success'))
          self.hideCreateDDModal();
          self.buttonDisabled = false;
          self.loadDataDiscovery();
          self.$emit('updated');
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.data_discovery_id) {
              self.error += ' ' + error.data.errors.data_discovery_id[0]
            }
          }
        })
      },
      formEditDDSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedDD) {
          this.ddForm.data_discovery_id = this.selectedDD.id;
        }

        this.ddForm.data_scanning = this.selectedDropdownOption.value

        piincHttp.put('systems/' + this.system.slug + '/data-discoveries/' + this.object.id, this.ddForm).then(function() {
          self.hideEditDDModal();
          self.loadDataDiscovery();
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('systems.data_discovery.edit.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.data_discovery_id) {
              self.error += ' ' + error.data.errors.data_discovery_id[0]
            }
          }
        })
      },
      loadDD(query) {
        let self = this;
        piincHttp.get('data-discoveries', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.ddItems = response.data.items
          if (self.ddItems && !self.ddItems.length && !query) {
            self.ddItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          if (self.ddItems && self.ddItems.length) {

            self.dropdownOptions = []
            _.forEach(self.ddItems[0].dataScanningOptions, function(item) {
              let object = {
                name: self.$t('systems.data_discovery.' + self.$options.filters.slugify(item)),
                value: item
              }
              self.dropdownOptions.push(object)
            })

          }
          self.setDisabledValidations();
        }, function() {});
      },
      setDisabledValidations() {
        this.disabledValidationOptions = [];
        if (this.system.dataDiscoveriesValidation.data_scanning == false) {
          this.disabledValidationOptions.push('Data scanning')
        }
      }
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        this.loadDD();
      }
      if (this.system && this.system.id) {
        this.loadTasks('update_data_discovery');
        this.loadDataDiscovery();
        this.validationOptions = _.cloneDeep(this.system.dataDiscoveryValidationOptions)
      }


      this.loadGuides('update_data_discovery');
    }
  }
</script>
